// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addCertificateBtn[data-v-d96b0414]{color:#286ab4;font-weight:700;font-size:15px}.addCertificateBtn img[data-v-d96b0414]{height:15px;position:relative;top:2px;cursor:pointer}.addCertificateBtn span[data-v-d96b0414]{cursor:pointer}.certificateState[data-v-d96b0414]{margin-left:20px;font-size:14px}.show-files[data-v-d96b0414]{width:50%;text-align:center;color:#286ab4;cursor:pointer}", ""]);
// Exports
module.exports = exports;
